<!-- 引导授权卡片 -->
<template>
    <div
        v-visually="{
            serverId: 17096,
            area: 'btn-card-ydsq',
        }"
        class="guide-card"
    >
        <div class="main">
            <div class="icon"></div>
            <div class="content">海量会员专享权益待您咨询～</div>
        </div>
        <div class="btn" @click="handleAuthorize">授权电联 了解权益</div>
    </div>
</template>

<script>
import {authorize} from '../../../utils/commonReq';
export default {
    data() {
        return {
            isSubmitting: false
        };
    },
    methods: {
        handleAuthorize() {
            if (this.isSubmitting) {
                return;
            }
            this.$wywLog.send({
                serverId: 17096,
                area: 'btn-card-ydsq',
                action: 'click'
            });
            this.isSubmitting = true;
            authorize().then(() => {
                this.$emit('showAuthorizeDialog');
            }).finally(() => {
                this.isSubmitting = false;
            });
        }
    }
};
</script>

<style lang='less' scoped>
.guide-card {
    width: 158px;
    box-shadow: 0 0 6px 0 rgba(227,229,234,0.40);
    border-radius: 12px;
    padding: 14px 12px;
    position: fixed;
    right: 55px;
    bottom: 70px;
    background: #fff;
    z-index: 99;

    .main {
        display: flex;
    }

    .icon {
        height: 62px;
        width: 50px;
        background: url('https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/law-girl.png') no-repeat center center / 100% 100%;
        margin-left: 5px;
    }

    .content {
        width: 60px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #333333;
        line-height: 17px;
        margin-top: 4px;
        margin-left: 10px;
    }

    .btn {
        background-image: linear-gradient(90deg, #FFE99E 1%, #FFDC68 100%);
        border-radius: 5px;
        padding: 7px 8px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #A54300;
        text-align: center;
        line-height: 16px;
        cursor: pointer;
    }
}
</style>
